import React from "react"
import LogoWhite from '../../Images/logo_white.png'
import LogoGifWhite from '../../Images/white_logo_one_repetition.gif'
import { Layout, Row, Col, Card, Typography, Affix, Button, Icon } from 'antd'
import { withRouter } from 'react-router-dom'
const { Content } = Layout;
const { Title } = Typography;

class LoginBase extends React.Component {

    render() {
        return(
            <Layout>
                <Content
                    style={{
                        // background: "linear-gradient(to right, #353FDF, #49ECAD)"
                        background: "#353FDF"
                    }}
                >
                    {
                        !this.props.hideHomeButton &&
                            <Affix
                                offsetTop={15}
                            >
                                <Button onClick={(e) => this.props.history.push('/login')} >
                                    <Icon type="home" />
                                </Button>
                            </Affix>
                    }
                    <Row
                        type="flex"
                        justify="space-around"
                        align="middle"
                        style={{
                            minHeight:"100vh"
                        }}
                    >
                        <Col
                            xs={22}
                            sm={20}
                            lg={12}
                            xl={8}
                        >
                            <center>
                            <img alt="logo-white" src={LogoGifWhite} className="logo-white" style={{ width: "100%"}} />
                            {/* <img alt="error" src={LogoWhite} className="error-checkout"style={{ marginBottom: "15px" }}  /> */}
                            </center>
                            <Card
                                style={{
                                    borderRadius:"20px",
                                    height:"auto",
                                    textAlign:"center",
                                    marginTop:"5px",
                                    paddingTop: "40px",
                                    paddingBottom: "20px",
                                    marginBottom:'5px',
                                    borderTop: '#ffffff'
                                }}
                            >
                                
                                <Title
                                    level={2}
                                    style={{
                                        marginBottom:"40px"
                                    }}
                                >
                                    <b>
                                        {this.props.title}
                                    </b>
                                </Title>
                                {this.props.children}
                            </Card>
                        </Col>
                    </Row>
                </Content>
            </Layout>
        );
    }
}

export default withRouter(LoginBase);